import { ReactNode } from 'react';
import './TeamMember.scss';

export type Socials = {
    linkedIn: string | undefined;
    gitHub: string | undefined;
}

const TeamMember = ({imageURL, displayName, title, pronouns, children, socials} : {
    imageURL: string;
    displayName: string;
    title: string;
    pronouns: string;
    children: ReactNode;
    socials?: Socials;
}) => {
    return (
        <article className="team-member" aria-label="Collective Leader">
            <div className='profile'>
                <img 
                    src={imageURL}
                    width={200}
                    alt={displayName}
                />
                {socials && 
                <div className='socials-bar'>
                    {socials.linkedIn && 
                    <a href={socials.linkedIn} target='_blank'>
                        <img 
                            src='/icons/linkedin.svg' 
                            width={24} 
                            alt={`${displayName}'s LinkedIn`}
                    />
                    </a>
                    }
                    {socials.gitHub && 
                    <a href={socials.gitHub} target='_blank'>
                        <img 
                            src='/icons/github.svg' 
                            width={24} 
                            alt={`${displayName}'s GitHub`}
                    />
                    </a>
                    }
                </div>}
            </div>
            <div className='info-content'>
                <h3 className="collective-leader">{displayName}</h3>
                <h5 className="pronouns">{pronouns}</h5>
                <h4 className="collective-title">{title}</h4>
                {children}
            </div>
        </article>
    )
}

export default TeamMember;